<template>
  <div>
    <p slot="header" class="effect-tips">请务必双签确认含相反相畏的处方！</p>
    <div class="signbox">
      <div class="signbox-content">
        <div v-for="(val, ind) in effectsDrugs" :key="ind">
          <div class="drug-title color1F23 size14 font500">{{ val.name }}</div>
          <div class="item">
            <div class="item-drug" v-for="item in val.effectsDrugs" :key="item.sideEffectsId">
              <div><span>{{ item.drugNameOne }}</span> 和 <span>{{ item.drugNameTwo }}</span> {{ item.type == '0' ? '相反'
                : '相畏' }}
              </div>
              <label>{{ doctorInfo.doctorName[0] }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <span slot="footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="doctorSign">确 定</el-button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 定义引入的组件
  components: {},
  props: {
    effectsDrugs: {
      type: Array,
      default: () => []
    },
    excessDrugs: {
      type: Array,
      default: () => []
    },
    doctorInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() { },
  // 页面DOM加载完成
  mounted() {
    console.log('effectsDrugs', this.effectsDrugs);
  },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    // 医生签名
    doctorSign() {
      // let recipeDrugs = this.editForm.recipeDrugs;
      // recipeDrugs.forEach(item => {
      //     item.recipeDrugItem.forEach(kid => {
      //         this.names.forEach(child => {
      //             if (kid.drugName == child) kid.isSign = 1;
      //         })
      //     });
      // });
      this.$emit('doctorSign')
      // // 保存病历
      // this.edit(this.signRequest.request, this.signRequest.msg);
      // this.signVisible = false;
    },
    /**
     * 取消
     */
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="less" scoped>
// 相反相畏提示
.effect-tips {
  padding: 10px;
  font-size: 14px;
  color: #FE8F1F;
  text-align: center;
  background: #FFFBE8;
}

// 相反相畏内容区域
.signbox {

  .drug-title {
    padding-left: 6px;
    font-size: 14px;
    border-left: 3px solid #1890FF;
  }

  .signbox-content {
    padding: 10px 24px;
    max-height: 450px;
    overflow: auto;
  }

  .item {
    padding: 0 10px;
    line-height: 20px;
    border: 1px solid #EBEAEE;
    border-radius: 4px;
    box-sizing: border-box;
    background: #F7F8F9;
    margin-bottom: 10px;
    margin-top: 10px;

    .item-drug {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 10px 0;

      span {
        color: #FE8F1F;
        font-weight: bold;
      }

      label {
        width: 32px;
        height: 32px;
        line-height: 20px;
        border-radius: 50%;
        border: 6px double #D3D3D5;
        text-align: center;
        font-size: 13px;
        font-weight: bold;
        font-family: '楷体';
        box-sizing: border-box;
        font-weight: bold;
        color: #667182;
      }
    }

    .mini {
      font-size: 20px;
    }
  }

  .dialog-footer {
    padding: 12px 24px 16px;
    text-align: right;
  }
}
</style>